import React, { useState } from "react";
import Slider from "react-slick";

import CardLaboratory from "../../atoms/cardLaboratory/cardLaboratory";

import "./laboratoriesSlider.scss";

interface LaboratoriesSliderInter {
  laboratories: any;
}

const LaboratoriesSlider = (props: LaboratoriesSliderInter) => {
  const [sliderIndex, setSliderIndex] = useState(0);
  const [slider, setSlider] = useState<any>();

  // Funciones para desktop
  const goToNext = () => {
    slider.slickGoTo(sliderIndex + 1);
  };

  const goToBack = () => {
    slider.slickGoTo(sliderIndex - 1);
  };

  const isActiveNext = (_true: any, _false: any) => {
    return sliderIndex < props.laboratories.length - 1 ? _true : _false;
  };

  const isActiveBack = (_true: any, _false: any) =>
    sliderIndex > 0 ? _true : _false;

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1.75,
    slidesToScroll: 1,
    beforeChange: (_: number, next: number) => setSliderIndex(next),
  };

  return (
    <section className="m-laboratory-slider">
      <div className="hide-on-mobile">
        <Slider ref={(_slider) => setSlider(_slider)} {...settings}>
          {props.laboratories.filter(lab => lab.imgUrl).map((laboratory, idx) => {
            return (
              <div className="laboratory-desktop" key={idx}>
                <CardLaboratory
                  titleDescription={laboratory.titleDescription}
                  titleBanner={laboratory.titleBanner}
                  description={laboratory.description.json}
                  typeTitle={laboratory.typeTitle}
                  imgUrl={laboratory.imgUrl[0]}
                  bottonRedirect={laboratory.bottonRedirect}
                  nombreCategoria={laboratory.nombreCategoria}
                  tituloGeneral={laboratory.tituloGeneral}
                  key={idx}
                />
              </div>
            );
          })}
        </Slider>
        <div
          className="arrow-content arrow-content__left"
          onClick={isActiveBack(goToBack, undefined)}
        >
          <div className="arrows">
            <div className="arrows-contain">
              <div
                className={isActiveBack(
                  "arrow icon-chevron-left active",
                  "arrow icon-chevron-left"
                )}
              />
            </div>
          </div>
        </div>
        <div
          className="arrow-content arrow-content__right"
          onClick={isActiveNext(goToNext, undefined)}
        >
          <div className="arrows">
            <div className="arrows-contain">
              <div
                className={isActiveNext(
                  "arrow icon-chevron-right active",
                  "arrow icon-chevron-right"
                )}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LaboratoriesSlider;
